import {yupResolver} from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';
import {Button, Grid} from '@mui/material';
import React, {useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {i18n} from 'src/i18n';
import codificacionISOEnumerators from 'src/modules/codificacionISO/codificacionISOEnumerators';
import yupFormSchemas from 'src/modules/shared/yup/yupFormSchemas';
import InputFormItem from 'src/view/shared/form/items/InputFormItem';
import SelectFormItem from 'src/view/shared/form/items/SelectFormItem';
import SwitchFormItem from 'src/view/shared/form/items/SwitchFormItem';
import FormWrapper, {FormButtons} from 'src/view/shared/styles/FormWrapper';
import * as yup from 'yup';

const schema = yup.object().shape({
  reporte: yupFormSchemas.enumerator(i18n('entities.codificacionISO.fields.reporte'), {
    required: true,
    options: codificacionISOEnumerators.reporte,
  }),
  codigo: yupFormSchemas.string(i18n('entities.codificacionISO.fields.codigo'), {
    required: true,
  }),
  revision: yupFormSchemas.string(i18n('entities.codificacionISO.fields.revision'), {}),
  habilitado: yupFormSchemas.boolean(i18n('entities.codificacionISO.fields.habilitado'), {}),
});

function CodificacionISOForm(props) {
  const [initialValues] = useState(() => {
    const record = props.record || {};

    return {
      reporte: record.reporte,
      codigo: record.codigo,
      revision: record.revision,
      habilitado: record.habilitado,
    };
  });

  const form = useForm({
    resolver: yupResolver(schema),
    mode: 'all',
    defaultValues: initialValues as any,
  });

  const onSubmit = (values) => {
    props.onSubmit(props.record?.id, values);
  };

  const onReset = () => {
    Object.keys(initialValues).forEach((key) => {
      form.setValue(key, initialValues[key]);
    });
  };

  const {saveLoading, modal} = props;

  return (
    <FormWrapper>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Grid spacing={2} container>
            <Grid item lg={7} md={8} sm={12} xs={12}>
              <SelectFormItem
                name="reporte"
                label={i18n('entities.codificacionISO.fields.reporte')}
                options={codificacionISOEnumerators.reporte.map((value) => ({
                  value,
                  label: i18n(`entities.codificacionISO.enumerators.reporte.${value}`),
                }))}
                required={true}
              />
            </Grid>
            <Grid item lg={7} md={8} sm={12} xs={12}>
              <InputFormItem name="codigo" label={i18n('entities.codificacionISO.fields.codigo')} required={true} />
            </Grid>
            <Grid item lg={7} md={8} sm={12} xs={12}>
              <InputFormItem name="revision" label={i18n('entities.codificacionISO.fields.revision')} required={false} />
            </Grid>
            <Grid item lg={7} md={8} sm={12} xs={12}>
              <SwitchFormItem name="habilitado" label={i18n('entities.codificacionISO.fields.habilitado')} />
            </Grid>
          </Grid>
          <FormButtons
            style={{
              flexDirection: modal ? 'row-reverse' : undefined,
            }}>
            <Button
              variant="contained"
              color="primary"
              disabled={saveLoading}
              type="button"
              onClick={form.handleSubmit(onSubmit)}
              startIcon={<SaveIcon />}
              size="small">
              {i18n('common.save')}
            </Button>

            <Button disabled={saveLoading} onClick={onReset} type="button" startIcon={<UndoIcon />} size="small">
              {i18n('common.reset')}
            </Button>

            {props.onCancel ? (
              <Button
                disabled={saveLoading}
                onClick={() => props.onCancel()}
                type="button"
                startIcon={<CloseIcon />}
                size="small">
                {i18n('common.cancel')}
              </Button>
            ) : null}
          </FormButtons>
        </form>
      </FormProvider>
    </FormWrapper>
  );
}

export default CodificacionISOForm;
